import { Injectable } from "@angular/core";
import { firstValueFrom } from "rxjs";
import { QueryResult } from "../../../common/rest-api/models/query-result";
import { RequestParams } from "../../../common/rest-api/models/request-params";
import { RestApiService } from "../../../common/rest-api/services/rest-api.service";
import { CommonService } from '../../../common/services/common.service';
import {
  RouteDeliveryDetails,
  RouteDeliveryDetailsFreq,
  RouteDeliveryDetailsPickup,
} from "../models/route-delivery-details.model";
import { Route } from "@angular/router";

@Injectable({
  providedIn: "root",
})
export class RouteDeliveryDetailsService extends RestApiService<RouteDeliveryDetails> {
  protected resourcePath = "/route-detail";
  protected modelType = RouteDeliveryDetails;

  async GetDeliveryList(
    stopCode: string,
    routeCode: string,
    forDate: string,
  ): Promise<RouteDeliveryDetailsFreq[]> {
    //convert date to yyyy-mm-dd format
    const url = this.buildEndpointUrl(
      `delivery/${stopCode}/${routeCode}/${forDate}`
    );
    
    const response = await this.cloudApiMiddleware.cloudRequest<RouteDeliveryDetailsFreq[]>({
      url
    }, 'GET');

    return response;
  }

  async GetPickupList(
    stopCode: string,
    routeCode: string,
    forDate: string,
    dayOfPeriod: number
  ): Promise<RouteDeliveryDetailsPickup[]> {
    //convert date to yyyy-mm-dd format
    // const forDateStr = forDate.toISOString().split('T')[0];
    const url = this.buildEndpointUrl(
      `pickup/${stopCode}/${routeCode}/${forDate}/${dayOfPeriod}`
    );

    const response = await this.cloudApiMiddleware.cloudRequest<RouteDeliveryDetailsPickup[]>({
      url
    }, 'GET');

    return response;
  }

  async GetNumberOfPickups(
    stopCode: string,
    routeCode: string,
    forDate: string,
    dayOfPeriod: number
  ): Promise<number> {
    //convert date to yyyy-mm-dd format
    const url = this.buildEndpointUrl(
      `pickup-count/${stopCode}/${routeCode}/${forDate}/${dayOfPeriod}`
    );

    const response = await this.cloudApiMiddleware.cloudRequest<number>({
      url
    }, 'GET');

    return response;
  }

  async UpdatePickupList(pickupList: RouteDeliveryDetailsPickup[], forDate:string) {
    const url = this.buildEndpointUrl(`pickup-update/${forDate}`);

    const response = await this.cloudApiMiddleware.cloudRequest<string>({
      url,
      body: pickupList
    }, 'PUT');
    
    return response;
  }
}
